/**
 * What the renewal form refuses before sending, in the words the server uses.
 *
 * Everything but the number is required, as the client asked: the new issue
 * date, the new expiry date and a copy. The number is asked only of a paper
 * that has one, and only when it changed.
 */
export interface RenewalInput {
  issued: string;
  expires: string;
  hasFile: boolean;
}

export type RenewalProblems = Partial<Record<"issued" | "expires" | "file", string>>;

export function renewalProblems(input: RenewalInput, today: string): RenewalProblems {
  const problems: RenewalProblems = {};
  if (!input.issued) problems.issued = "Enter the new issue date.";
  if (!input.expires) problems.expires = "Enter the new expiry date.";
  else if (input.issued && input.expires < input.issued) {
    problems.expires = "The expiry date cannot be before the issue date.";
  } else if (input.expires <= today) {
    problems.expires = "The new expiry date has already passed.";
  }
  if (!input.hasFile) problems.file = "Attach a copy of the new one.";
  return problems;
}

/**
 * A paper's name as it reads inside a sentence: "the labour card", but
 * "the Emirates ID", whose capitals are part of the name.
 */
export function inSentence(label: string): string {
  if (/\b[A-Z]{2,}\b/.test(label)) return label;
  return label.charAt(0).toLowerCase() + label.slice(1);
}

/** A task the employee completes with the renewal form rather than a plain upload. */
export function isRenewalTask(task: { key: string }): boolean {
  return task.key.startsWith("renewal:");
}
